import React, { FC, useState } from 'react';

type IncentiveData = {
  incentive: string;
  value: string;
};

type IncentiveTableProps = {
  data: IncentiveData[];
  heading1: string;
  heading2: string;
};
const ITEMS_PER_PAGE = 8;

const IncentiveTable: FC<IncentiveTableProps> = ({
  data,
  heading1,
  heading2,
}) => {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(data.length / ITEMS_PER_PAGE);

  const handlePageChange = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getItemsForCurrentPage = () => {
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    return data.slice(startIndex, endIndex);
  };

  return (
    <div className="container mx-auto px-0 md:px-4 ">
      <div className="flex flex-col items-center justify-center p-1 md:p-6 bg-white rounded-lg shadow-xl">
        <table className="table-auto w-full text-left border-collapse">
          <thead>
            <tr>
              <th className="py-4 px-6 bg-blue-500 text-white font-bold uppercase text-sm">
                {heading1}
              </th>
              <th className="py-4 px-6 bg-blue-500 text-white font-bold uppercase text-sm">
                {heading2}
              </th>
            </tr>
          </thead>
          <tbody>
            {getItemsForCurrentPage().map((row, index) => (
              <tr key={index} className="hover:bg-gray-100">
                <td className="py-4 md:px-6 px-3 border-b border-gray-200 text-sm md:text-base">
                  {row.incentive}
                </td>
                <td className="py-4 px-1 md:px-6 border-b border-gray-200 text-sm md:text-base">
                  {row.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Show pagination only if there are more than one page */}
        {totalPages > 1 && (
          <div className="flex justify-center mt-6 space-x-4">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-white bg-blue-500 rounded-lg disabled:opacity-50"
            >
              Previous
            </button>
            <span className="flex items-center justify-center px-4 py-2 text-gray-700">
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-white bg-blue-500 rounded-lg disabled:opacity-50"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default IncentiveTable;
